import type { ReactNode } from 'react';
import { Message } from '@gonfalon/messages/Message';
import { msg } from '@gonfalon/messages/msg';
import { HelpTooltip } from '@gonfalon/ui/HelpTooltip';

interface EventFilterInfoTooltipProps {
  labelText?: string;
  children?: ReactNode;
}

// Shared help-tooltip trigger for the event-filter UI. The default copy matches the legacy
// (flag-off) MetricEventFilters usage so that path is unchanged; the flag-on two-bar QueryBuilder
// passes its own per-bar context-attribute / event-property descriptions.
// Uses the shared HelpTooltip (Focusable + role="button" trigger) so the tooltip trigger is a real
// interactive element — wrapping a non-interactive Icon in <Pressable> is an accessibility defect.
export const EventFilterInfoTooltip: React.FC<EventFilterInfoTooltipProps> = ({ labelText, children }) => (
  <HelpTooltip labelText={labelText ?? msg('metrics.eventFilters.aboutFilters')}>
    <>{children ?? <Message id="metrics.eventFilters.aboutFiltersHelp" />}</>
  </HelpTooltip>
);
